import { MagicCopyPermission, UserRight } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const enterpriseTagSchema = {
    displayName: 'enterprise tag',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        name: {
            type: 'shortString',
            required: true,
            validationRegex: '^[a-z0-9]+(-[a-z0-9]+)*$',
            writeRight: UserRight.BiteEng,
            tooltip: {
                text: 'Lowercase identifier in kebab-case (e.g. "aramark", "starbucks-lc").',
            },
        },
        magicCopyPermission: {
            displayName: 'Magic Copy Permission',
            type: 'stringEnum',
            enum: MagicCopyPermission,
            required: true,
            ui: 'dropdown',
            writeRight: UserRight.BiteEng,
        },
    },
};
//# sourceMappingURL=enterprise_tag_schema.js.map